var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "content"
  }, [_c('slider', {
    attrs: {
      "animation": "normal",
      "auto": true,
      "height": "900px"
    }
  }, [_c('slider-item', [_c('img', {
    staticClass: "sliderImage",
    attrs: {
      "src": require("../assets/img/slider.png"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('slider-item', [_c('img', {
    staticClass: "sliderImage",
    attrs: {
      "src": require("../assets/img/slider2.jpg"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('slider-item', [_c('img', {
    staticClass: "sliderImage",
    attrs: {
      "src": require("../assets/img/slider3.jpg"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('slider-item', [_c('img', {
    staticClass: "sliderImage",
    attrs: {
      "src": require("../assets/img/slider4.jpg"),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols"
  }, [_c('b-row', {
    staticClass: "justify-content-md-center textCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align-v": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/profile.png")
    }
  })])], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "sign"
  }, [_vm._v("Beatiful photography refueled")]), _vm._v(" "), _c('p', {
    staticClass: "separator"
  }, [_vm._v("— • —")])])], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "greetingText"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center imgCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/sign.png")
    }
  })])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center mb-5 cf"
  }, _vm._l((_vm.media), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "2",
        "sm": "2",
        "md": "1",
        "lg": "1"
      }
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "title": item.title
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgWhite
      }
    }), _c('img', {
      staticClass: "top",
      attrs: {
        "src": item.imgHover
      }
    })])])
  })), _vm._v(" "), _c('b-row', {
    staticClass: "text-center d-sm-flex d-none"
  }, _vm._l((_vm.items), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "6",
        "lg": "4",
        "xl": "3",
        "align-v": "center"
      }
    }, [_c('div', {
      staticClass: "card-container"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "side"
    }, [_c('img', {
      directives: [{
        name: "img",
        rawName: "v-img:my-group",
        arg: "my-group"
      }],
      staticClass: "galleryItem",
      attrs: {
        "src": item.image,
        "alt": item.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "side back"
    }, [_vm._v(_vm._s(item.desc))])])])])
  })), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "imgCentred",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align-v": "center"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/Albums"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_c('div', {
    staticClass: "button"
  }, [_vm._v("VIEW ALL WORK")])])], 1)], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    staticClass: "imgCentred",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "6"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/img/flowers.png")
    }
  })]), _vm._v(" "), _c('b-col', {
    staticClass: "imgCentred",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "6"
    }
  }, [_c('p', {
    staticClass: "sign text-left"
  }, [_vm._v("Best Photogrpaher For Wedding Events")]), _vm._v(" "), _c('p', {
    staticClass: "description",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in")]), _vm._v(" "), _c('p', {
    staticClass: "description",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Eimpedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/Master"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_c('div', {
    staticClass: "button leftSide"
  }, [_vm._v("READ MORE")])])], 1)], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "sign"
  }, [_vm._v("Our philosophy")]), _vm._v(" "), _c('p', {
    staticClass: "separator"
  }, [_vm._v("— • —")])])], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    staticClass: "imgCentred",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "6",
      "align-v": "center"
    }
  }, [_c('p', {
    staticClass: "sign text-left"
  }, [_vm._v("Best solution  for any event")]), _vm._v(" "), _c('p', {
    staticClass: "description",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et")]), _vm._v(" "), _c('p', {
    staticClass: "description",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est,")]), _vm._v(" "), _c('p', {
    staticClass: "description",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/Service"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_c('div', {
    staticClass: "button leftSide"
  }, [_vm._v("READ MORE")])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "imgCentred",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "6"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/img/photographer.png")
    }
  })])], 1)], 1), _vm._v(" "), _c('b-container', {
    staticClass: "d-md-inline-block d-none",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('div', {
    staticClass: "embed-responsive embed-responsive-4by3"
  }, [_c('article', {
    staticClass: "embed-responsive-item"
  }, [_c('h1', {
    staticClass: "videoSign"
  }, [_vm._v("Mikes Photography"), _c('br'), _vm._v(" "), _c('span', [_vm._v("(Made by "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_vm._v("Mike B")]), _vm._v(", for "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("ExtraVision")]), _vm._v(")")])])]), _vm._v(" "), _c('video', {
    staticClass: "embed-responsive-item",
    attrs: {
      "autoplay": "",
      "loop": "",
      "id": "video-background",
      "muted": "",
      "plays-inline": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "https://player.vimeo.com/external/158148793.hd.mp4?s=8e8741dbee251d5c35a759718d4b0976fbf38b6f&profile_id=119&oauth2_token_id=57447761",
      "type": "video/mp4"
    }
  })])])])], 1)], 1)], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07c72eec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = DYMY
// module chunks = 0